import React, { Fragment } from 'react';
import { SyncDirectionWrapper, StyledButton } from '../styles/calendarIntegration.styles';
import Select from 'react-select';
import { VscLoading } from 'react-icons/vsc';
import DynamicChannelSelectFilter from '@/components/Admin/DynamicChannelSelectFilter';
import { GoToChannel } from '@/_elements/Links';
import OurAccordion from '@/_elements/OurAccordion';
import { Checkbox } from '@/_elements/FormElements';
import { ConsentToolTip } from '@/_elements/ToolTip';

const syncDirectionOptions = [
    { value: 'TWO_WAY', label: 'Two-way Sync' },
    { value: 'OUTBOUND', label: 'Optonome → Personal' },
    { value: 'INBOUND', label: 'Personal → Optonome' },
];

const syncFutureOptions = [
    { value: 30, label: '30 days' },
    { value: 60, label: '60 days' },
    { value: 90, label: '90 days' },
];

const ExternalCalendarAccountSettings = ({
    teams,
    account,
    formState,
    setFormState,
    isBusy,
    isSaving,
    isSyncing,
    selectedChannelOption,
    setSelectedChannelOption,
    handleSaveSettings,
}) => {
    const calendarProvider = (account?.calendarProvider || '').toLowerCase();
    return (
        <div className="p-4">
            {/* <OurAccordion defaultShow={false} title={<span className="text-muted">Calendar Settings</span>}> */}
            <SyncDirectionWrapper>
                <span className="text-muted small">Sync Direction:</span>
                <Select
                    value={syncDirectionOptions.find((opt) => opt.value === formState.syncDirection)}
                    onChange={(opt) => setFormState((prev) => ({ ...prev, syncDirection: opt?.value }))}
                    options={syncDirectionOptions}
                    styles={{
                        control: (base) => ({ ...base, minWidth: '250px' }),
                    }}
                    isDisabled={isBusy || isSaving || isSyncing}
                />
            </SyncDirectionWrapper>
            <SyncDirectionWrapper>
                <span className="text-muted small">Sync Future Limit:</span>
                <Select
                    value={syncFutureOptions.find((opt) => opt.value === formState.syncFutureLimit) || null}
                    onChange={(opt) => setFormState((prev) => ({ ...prev, syncFutureLimit: opt?.value || null }))}
                    options={syncFutureOptions}
                    styles={{
                        control: (base) => ({ ...base, minWidth: '250px' }),
                    }}
                    isDisabled={isBusy || isSaving || isSyncing}
                />
            </SyncDirectionWrapper>
            {/* <SyncDirectionWrapper>
                <div className="d-flex flex-row">
                    <div className="text-muted small">Activity Library Channel:</div>
                    <ConsentToolTip text="Choose a channel to copy new events to." />
                    <ConsentToolTip
                        color={'red'}
                        text={`⚠️ It may copy all ${calendarProvider} events to this channel, if selected `}
                    />
                </div>
                <div className="d-flex flex-row">
                    {selectedChannelOption && selectedChannelOption?.value && (
                        <GoToChannel channel={{ ...selectedChannelOption, title: '', label: '' }} />
                    )}
                    <DynamicChannelSelectFilter
                        selectedOption={selectedChannelOption}
                        onRoomSelect={setSelectedChannelOption}
                        assignedChannel={selectedChannelOption?.value}
                        placeholder="Search and select a channel..."
                        teamIds={(teams || []).map((t) => t._id)}
                        permissionRule="get:chatrooms"
                        disabled={isBusy || isSaving || isSyncing}
                    />
                </div>
            </SyncDirectionWrapper> */}
            <SyncDirectionWrapper>
                <div className="d-flex flex-row">
                    <div className="text-muted small">Show personal events in calendar:</div>
                    <ConsentToolTip
                        text={`Applies to view-only ${calendarProvider} events from Personal Events Library.`}
                    />
                </div>
                <div className="d-flex flex-row">
                    <Checkbox
                        value={!!!formState?.hideFromCalendar}
                        onChange={() => {
                            setFormState((prev) => ({ ...prev, hideFromCalendar: !!!prev.hideFromCalendar }));
                        }}
                        disabled={isBusy || isSaving || isSyncing}
                    />
                </div>
            </SyncDirectionWrapper>
            <SyncDirectionWrapper>
                <div className="d-flex flex-row">
                    <div className="text-muted small">Sync copied events to team/channel:</div>
                    <ConsentToolTip
                        text={`Update title, description & dates for future changes to copied events, when its updated in ${calendarProvider}`}
                    />
                    <ConsentToolTip
                        color={'red'}
                        text={`⚠️If enabled, Frequent updates to ${calendarProvider} and copied event and copied channel events may cause unexpected behavior`}
                    />
                </div>
                <div className="d-flex flex-row">
                    <Checkbox
                        value={formState?.syncCopiedTasks}
                        disabled={isBusy || isSaving || isSyncing}
                        onChange={() => {
                            setFormState((prev) => ({ ...prev, syncCopiedTasks: !!!prev.syncCopiedTasks }));
                        }}
                    />
                </div>
            </SyncDirectionWrapper>
            <SyncDirectionWrapper className="mt-4 mb-4">
                <div></div>
                <StyledButton variant="primary" onClick={handleSaveSettings} disabled={isBusy || isSaving || isSyncing}>
                    Save
                    {isSaving && <VscLoading className="spin ml-2" />}
                </StyledButton>
            </SyncDirectionWrapper>
            {/* </OurAccordion> */}
        </div>
    );
};

export default ExternalCalendarAccountSettings;
